<!--
 * @Description: dialog 表单
 * @Author: luozhong
 * @Date: 2020-11-17 00:20:53
-->
<template>
  <gg-dialog
    class="form-dialog"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="580px"
    v-loading="isLoading"
  >
    <div class="content">
      <template v-for="item in fromData">
        <slot v-if="item.renderHtml" name="renderHtml" :data="item"></slot>
        <gg-input
          v-else
          :class="[{ float: item.float }, item.className]"
          :key="item.key"
          :ref="item.key"
          v-model="item.value"
          :placeholder="item.placeholder"
          :error="errorObj[item.key]"
          :autofocus="item.autofocus"
        />
      </template>
      <p class="text-reminder reminder" v-if="textReminder">
        {{ textReminder }}
      </p>
      <p class="user-reminder reminder" v-if="userReminder">
        {{ userReminder }}
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <slot name="footer">
        <baseButton @click="cancel">{{ cancelBtnTxt }}</baseButton>
        <baseButton type="primary" :disabled="!isPass || !renderPass" @click="submit">{{
          submitBtnTxt
        }}</baseButton>
      </slot>
    </span>
  </gg-dialog>
</template>

<script>
export default {
  name: 'BaseFormDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    renderPass: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'title'
    },
    textReminder: {
      type: String,
      default: ''
    },
    userReminder: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    cancelBtnTxt: {
      type: String,
      default: 'Cancel'
    },
    submitBtnTxt: {
      type: String,
      default: 'Add'
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: this.value,
      isLoading: false,
      name: '',
      fromData: this.data,
      errorObj: {},
      isPass: false
    }
  },
  computed: {
    // 排除自定义插槽的表单数据
    dataExceptRender() {
      return this.fromData.filter((item) => !item.renderHtml)
    }
  },
  created() {
    if (this.title === 'Add a caption') {
      this.isPass = true
    }
  },
  watch: {
    value(res) {
      this.isShow = res
    },
    isShow(res) {
      this.$emit('input', res)
    },
    data(res) {
      this.fromData = res
    },
    fromData: {
      deep: true,
      handler(res) {
        res.forEach((item) => {
          if (item.value != '' && item.key != 'className') {
            this.valid()
            return false
          } else if (item.key == 'className') {
            this.valid()
            return false
          } else {
          }
        })
      }
    }
  },
  methods: {
    submit() {
      if (this.valid()) {
        this.$emit('submit', this.fromData, true)
      } else {
        this.$emit('submit', this.fromData, false)
      }
    },
    cancel() {
      this.isShow = false
    },
    valid() {
      //    this.errorObj = {};
      //    let isError = false;
      // try{
      // this.fromData.forEach((item) => {
      // 		   this.$refs[item.key] && (this.$refs[item.key][0].init = false);      // 提交之前先将每个input初始化字段设为false，要不无法触发默认错误提示
      //   if (item.reg && !item.reg.test(item.value)) {
      //     this.errorObj[item.key] = {
      //       show: true,
      //       message: item.errorText,
      //     };
      //     isError = true;
      //    this.isPass = !isError;
      // 		   throw Error();
      //   }
      // });
      // } catch (error) {}
      //    return !isError;
      this.errorObj = {}
      let isError = false
      try {
        this.fromData.forEach((item) => {
          // // 提交之前先将每个input初始化字段init,show设为false，要不无法触发默认错误提示
          // this.$refs[item.key][0].init = false;
          if (item.reg && !item.reg.test(item.value)) {
            this.errorObj[item.key] = {
              show: true,
              message: item.errorText
            }
            isError = true
            this.isPass = !isError
            // 只要有一个不符合条件就终止循环,跳出循环体
            throw Error()
          }
        })
      } catch (error) {}
      this.isPass = !isError
      return !isError
    }
  }
}
</script>

<style lang="less" scoped>
.form-dialog {
  /deep/ .el-dialog__header {
    font-family: OpenSans-Bold;
    height: 56px !important;
    line-height: 56px !important;
  }
  /deep/ .el-dialog__body {
    padding: 0 !important;
  }
  /deep/ .el-dialog__footer {
    padding-top: 20px !important;
    height: 76px !important;
    .base-button + .base-button {
      margin-left: 8px;
    }
  }
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /deep/ .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px;
    max-height: 444px;
    overflow: auto;
    .text-reminder {
      color: #b4b4b4;
    }
    .user-reminder {
      color: #202124;
    }
    .reminder {
      font-size: 12px;
      font-family: Roboto;
      & + .reminder {
        margin-top: 20px;
      }
    }
    // .float {
    //   width: calc(50% - 10px);
    //   float: left;
    //   &:nth-child(2n) {
    //     margin-left: 20px;
    //   }
    // }
    /deep/.float {
      width: calc(50% - 10px);
      flex-basis: calc(50% - 10px);
      flex-grow: 0;
      flex-shrink: 0;
      max-height: 48px;
    }
  }
}
</style>
